import { caseAssignmentAxiosInstance } from '../../../axios/caseAssignmentAxios';

const getAllRule = async (requestData: any) => {
  const params = {
    filters: requestData.params?.filters,
    search: requestData.params?.search,
    sortField: requestData.params?.sortField,
    sortOrder: requestData.params?.sortOrder,
    currentPage: requestData.params?.pagination.current,
    pageSize: requestData.params?.pagination.pageSize,
  };

  const url = `/caseAssignment/api/v1/rule`;
  const res = await caseAssignmentAxiosInstance.get(url, { params });
  return res.data;
};

const createRule = async (requestData: any) => {
  const url = `/caseAssignment/api/v1/rule`;
  const res = await caseAssignmentAxiosInstance.post(url, requestData);
  return res.data;
};

const updateRule = async (requestData: any) => {
  const { ruleId, payload } = requestData;
  const url = `/caseAssignment/api/v1/rule/id/${ruleId}`;
  const res = await caseAssignmentAxiosInstance.patch(url, payload);
  return res.data;
};

const deleteRule = async (requestData: any) => {
  const { ruleId } = requestData;
  const url = `/caseAssignment/api/v1/rule/id/${ruleId}`;
  const res = await caseAssignmentAxiosInstance.delete(url);
  return res.data;
};

const ruleService = {
  getAllRule,
  createRule,
  updateRule,
  deleteRule,
};

export default ruleService;
